import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CreaFiera.css";

function CreaFiera() {
    const navigate = useNavigate();

    const [step, setStep] = useState(1);

    const [luogo, setLuogo] = useState("");
    const [titolo, setTitolo] = useState("");
    const [dataFiera, setDataFiera] = useState("");

    const [error, setError] = useState("");
    const [saving, setSaving] = useState(false);
    const [successFlash, setSuccessFlash] = useState(false);

    const handleGoHome = () => navigate("/home");

    const canNextFromStep1 = luogo.trim() && titolo.trim();
    const canNextFromStep2 = dataFiera.trim();

    const formatDate = (isoDate) => {
        if (!isoDate) return "";
        const [anno, mese, giorno] = isoDate.split("-");
        return `${giorno}-${mese}-${anno}`;
    };

    const handleSaveFiera = async () => {
        setSaving(true);
        setError("");

        try {
            const res = await fetch("/api/fiera", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    luogo,
                    titolo,
                    data: dataFiera,
                    quadriSelezionati: []
                })
            });


            const data = await res.json();

            if (data.success) {
                setSuccessFlash(true);
                setTimeout(() => {
                    setSuccessFlash(false);
                    navigate("/home");
                }, 1000);
            } else {
                setError(data.message || "Errore nel salvataggio della fiera");
            }

        } catch (err) {
            setError("Errore di connessione al server");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="crea-fiera-page">
            <div id="container">

                {/* NAVBAR */}
                <div id="nav_bar">
                    <div id="logo_container">
                        <img id="logo_title" src={"logo-header.png"} alt="Logo" />
                    </div>

                    <div id="title">
                        <p>Crea Fiera</p>
                    </div>

                    <div id="logout_button">
                        <button id="logout" onClick={handleGoHome}>
                            Torna indietro
                        </button>
                    </div>
                </div>

                {/* LAYOUT */}
                <div id="layout_fiera">

                    {/* SIDEBAR STEPS */}
                    <div id="sidebar_steps">
                        <div className={`side_step ${step === 1 ? "active" : ""}`}>
                            <div className="side_number">1</div>
                            <span>Luogo e titolo</span>
                        </div>

                        <div className={`side_step ${step === 2 ? "active" : ""}`}>
                            <div className="side_number">2</div>
                            <span>Data</span>
                        </div>

                        <div className={`side_step ${step === 3 ? "active" : ""}`}>
                            <div className="side_number">3</div>
                            <span>Conferma</span>
                        </div>
                    </div>

                    {/* CONTENUTO */}
                    <div id="content_fiera">

                        {error && <p id="errore_text">{error}</p>}

                        {/* STEP 1 */}
                        {step === 1 && (
                            <div id="form_container_fiera">
                                <h2>Informazioni iniziali sulla fiera</h2>
                                <p className="form_description">
                                    Definisci il titolo e il luogo della fiera.
                                </p>

                                <div className="form_item full">
                                    <label>Titolo della fiera</label>
                                    <input
                                        type="text"
                                        value={titolo}
                                        onChange={(e) => setTitolo(e.target.value)}
                                        placeholder="Es. Romics, Fiera Romana..."
                                    />
                                </div>

                                <div className="form_item full">
                                    <label>Luogo della fiera</label>
                                    <input
                                        type="text"
                                        value={luogo}
                                        onChange={(e) => setLuogo(e.target.value)}
                                        placeholder="Inserisci il luogo..."
                                    />
                                </div>

                                <div className="buttons_step">
                                    <button
                                        className="btn-visualizza"
                                        disabled={!canNextFromStep1}
                                        onClick={() => setStep(2)}
                                    >
                                        Avanti
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* STEP 2 */}
                        {step === 2 && (
                            <div id="form_container_fiera">
                                <h2>Data della fiera</h2>

                                <div className="form_item full">
                                    <label>Data della fiera</label>
                                    <input
                                        type="date"
                                        value={dataFiera}
                                        onChange={(e) => setDataFiera(e.target.value)}
                                    />
                                </div>

                                <div className="buttons_step">
                                    <button
                                        className="btn-secondario"
                                        onClick={() => setStep(1)}
                                    >
                                        Indietro
                                    </button>

                                    <button
                                        className="btn-visualizza"
                                        disabled={!canNextFromStep2}
                                        onClick={() => setStep(3)}
                                    >
                                        Avanti
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* STEP 3 - CONFERMA */}
                        {step === 3 && (
                            <div id="form_container_fiera">
                                <h2>Conferma i dettagli della fiera</h2>

                                <p><strong>Titolo:</strong> {titolo}</p>
                                <p><strong>Luogo:</strong> {luogo}</p>
                                <p><strong>Data:</strong> {formatDate(dataFiera)}</p>

                                <div className="buttons_step">
                                    <button
                                        className="btn-secondario"
                                        onClick={() => setStep(2)}
                                    >
                                        Indietro
                                    </button>

                                    <button
                                        className={`btn-visualizza ${successFlash ? "btn-success-flash" : ""}`}
                                        disabled={saving}
                                        onClick={handleSaveFiera}
                                    >
                                        {saving
                                            ? "Salvataggio..."
                                            : successFlash
                                                ? "Fiera creata!"
                                                : "Conferma e crea fiera"}
                                    </button>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreaFiera;
